// extracted by mini-css-extract-plugin
module.exports = {"hr":"HorizontalRule_hr__39S-a","container":"HorizontalRule_container__dwBgJ","highlighted":"HorizontalRule_highlighted__1ifI6"};